import { render, staticRenderFns } from "./Ranges.vue?vue&type=template&id=c0a2607a&scoped=true"
import script from "./Ranges.vue?vue&type=script&lang=js"
export * from "./Ranges.vue?vue&type=script&lang=js"
import style0 from "./Ranges.vue?vue&type=style&index=0&id=c0a2607a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a2607a",
  null
  
)

export default component.exports